/* eslint-disable */
import React, { Component } from 'react';
import './corporateCardAccordion.css';
import { ACCORDION_STATUSES } from '../../../constants';
import { translateStatus } from '../../../utils';
import classnames from 'classnames';

// utils
import { Translations, convertStringToArrayForRadio } from '../../../utils';

// constant
import { FORM_REFS } from '../../../constants';

// restClient
import { eapiClient, aemHostClient } from '../../../restClient';

import WrappedDropDownSelect from '../DropDownSelect/DropDownSelect';
import SimpleDropdown from '../SimpleDropdown';
import WrappedInputField from '../InputField/InputField';
import GroupCheckBox from '../GroupedCheckBox/GroupedCheckBox';
import Checkbox from '../Checkbox/Checkbox';
import RadioButton from '../RadioButton/radioButton';
import FieldLabelToolTip from '../FieldLabelToolTip/fieldLabelToolTip';

import { getAggregateBoxMaxCount } from '../../CaseBody/ProductRequests/CaptureProductCorporateCard/mappingFile';

class CorporateCardAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      originalFormItems: {},
      showTooltip: false,
      setRelevantField: this.props.relevantFields
    };
    this.setPaymentTypeForDD = undefined;
    this.setRelevantField = this.props.relevantFields;
  }

  componentDidMount() {
    this.showNavAccordion();
    this.showNavAccordionOnEnter();
    this.props.accordionFields.formRef ? this.getFormRefData(FORM_REFS[this.props.accordionFields.formRef]) : '';

  }

  componentWillUnmount() {
    localStorage.clear();
  }

  getFormRefData = (formRefUrl) => {
    aemHostClient(formRefUrl)
      .then(({ data }) => {
        this.setState({
          originalFormItems: data
        })
      })
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang, this.props.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }

  getGroupCheckBoxValue = (_orderChain, _taxChain, _event) => {
    let _name = _event.checkBoxGroup;
    let _checkedBoxes = this.selectValueForComposedComponent(_orderChain, { name: _name });
    let relevantPrivlege = this.findRelevantCheckBoxTaxonomyGroup(_name);
    if (_event.isChecked) {
      //push the id, name pair in formData's checkedBoxes array
      //Check whether all checbox flag is set -> if yes, select all;
      if (_event.allCheckedFlag) {
        _checkedBoxes.length = 0;
        _checkedBoxes = relevantPrivlege.associations.map(
          (item, idx) => {
            return { id: item.id, name: item.name };
          }
        );
      } else {
        _checkedBoxes.push({ id: _event.id, name: _event.name });
      }
    } else {
      //filter the id, name pair from formData's checkedBoxes array
      //Check whether all checbox flag is set -> if yes, unselect all;
      if (_event.allCheckedFlag) {
        _checkedBoxes.length = 0;
        _checkedBoxes = [];
      } else {
        _checkedBoxes = _checkedBoxes.filter(
          chkBoxItem => {
            let allCheckSplit = chkBoxItem.id.split(':');
            if (chkBoxItem.id !== _event.id && allCheckSplit[allCheckSplit.length - 2] !== 'all') {
              return chkBoxItem;
            }
          }
        );
      }
    }
    return _checkedBoxes;
  }


  handleChange = (name, orderChain, taxonomyChain = '', currId) => e => {
    let value, _changedValue;
    let changedData;
    switch (e.type) {
      case 'dropDownSelectOperation':
        if (typeof e.updateValue !== 'object') {
          this.props.updateDisabledOptionArray(e);
        }
        value = e.updateValue;
        break;
      case 'inputFieldChangeOperation':
        value = e.value;
        break;
      case 'groupCheckBoxChange':
        value = this.getGroupCheckBoxValue(orderChain, taxonomyChain, e);
        name = e.checkBoxGroup;
        break;
      case undefined:
        //radio button event is captured here
        if (typeof e === 'object') {
          //This is the case for radio button having more than two options
          if (e.value === "true" || e.value === "false") {
            value = JSON.parse(e.value);
          } else {
            value = {
              name: e.name,
              value: e.value
            }
          }
        } else {
          value = e;
        }

        break;
      default:
        value = e.target.value || e.target.checked;
    }
    let splitName = name.split('_');
    if (splitName.length > 1) {
      let objectName = splitName[1];
      if (orderChain.length > 0 && orderChain[0] == splitName[0]) {
        //case where the aggregate box is on the first level of formData
        //for aggregate box on first level of formData the component split[0] will be same as first element of order chain

        let extractDataArray = this.props.formData[splitName[0]] || [];
        if (e.idx != -1) {
          if (typeof value === 'object' && Object.keys(value).length > 0) {
            let replaceData = { ...extractDataArray[e.idx], [objectName]: value };
            extractDataArray[e.idx] = replaceData;
          }
          else if (typeof value === 'string' && value.trim() !== "") {
            let replaceData = { ...extractDataArray[e.idx], [objectName]: value };
            extractDataArray[e.idx] = replaceData;
          }
          else {
            if (extractDataArray[e.idx][objectName]) {
              delete extractDataArray[e.idx][objectName];
            }
          }
        } else {
          if (typeof value === 'object' && Object.keys(value).length > 0) {
            let replaceData = { [objectName]: value };
            extractDataArray.push(replaceData);
          } else {
            if (typeof value === "string" && value.trim() !== "") {
              let replaceData = { [objectName]: value };
              extractDataArray.push(replaceData);
            }
          }
        }
        changedData = { ...this.props.formData, [splitName[0]]: extractDataArray };

      } else {
        //when orderChain is present -> meaning childern components for e.g. checkbox
        //for aggregate box NOT on the first level of formData.

        if (orderChain.length > 0 && orderChain[0] != splitName[0]) {
          let _isNewDataAdd = false;
          changedData = JSON.parse(JSON.stringify(this.props.formData));
          _changedValue = changedData[orderChain[0]];
          let loopLimit = splitName[1] === 'reportFormat' ? 4 : orderChain.length
          for (let k = 1; k < loopLimit; k++) {
            if (orderChain[k] == -1) {
              _isNewDataAdd = true;
              break;
            }
            _changedValue = _changedValue[orderChain[k]];
          };
          if (_isNewDataAdd) {
            if (splitName[0] == 'wps' || splitName[0] == 'spo' || splitName[0] === 'nonWps' || splitName[0] === 'so' || splitName[0] === 'sp' || splitName[0] === 'salary') {
              //This is special handling for payment types
              _changedValue.push({ [splitName[1]]: value, ['paymentType']: splitName[0] });
            }
            _changedValue.push({ [splitName[1]]: value });
          } else {
            if (splitName[1] === 'reportFormat') {
              let reportFormat = [];
              if (value) {
                reportFormat.push(value);
                _changedValue.reportFormat = reportFormat;
              } else {
                if (_changedValue.reportFormat) {
                  delete _changedValue.reportFormat;
                }
              }
            } else {
              if (value) {
                _changedValue[splitName[1]] = value;
              } else {
                if (_changedValue[splitName[1]]) {
                  delete _changedValue[splitName[1]]
                }
              }
            }

          }
        } else {
          if (orderChain.length <= 0) {
            changedData = JSON.parse(JSON.stringify(this.props.formData));
            changedData[splitName[1]] = value;
          }
        }
      }
    } else {
      //case when the components are simple like dropdown, checkbox or inputbox and are at first level of formData

      if (e.target && e.target.checked !== undefined) {
        //Case for handling checkboxes
        let propsGroupPosition;
        let taxonomyParent = taxonomyChain;
        if (name === 'wps' || name === 'spo' || name === 'nonWps' || name === 'so' || name === 'sp' || name === 'salary') {
          propsGroupPosition = 9;
          let itemLabelObject = this.getLabelFromTaxonomy(taxonomyParent + ':' + name, propsGroupPosition);
          changedData = { ...this.props.formData };

          let _foundPayment = false, payIdx;
          for (let p = 0; p < this.props.formData.paymentTypes.length; p++) {
            if (this.props.formData.paymentTypes[p].paymentType.value === itemLabelObject.id) {
              _foundPayment = true;
              payIdx = p;
              break;
            }
          }
          if (_foundPayment) {
            if (e.target.checked) {
              changedData.paymentTypes[payIdx]['paymentType'] = {
                ['name']: itemLabelObject.name,
                ['value']: itemLabelObject.id
              };
            } else {
              //uncheck the payment checkboxes and remove the dropdown selected options in checkboxe's children from disabledOptionsArray
              let removeEntriesObjArray = [];
              for (let [k, v] of Object.entries(changedData.paymentTypes[payIdx])) {
                if (this.props._dropDownDataSourceMap.has(k)) {
                  if (v && v.trim() !== "") {
                    let removeEntryObj = this.getDropDownRemoveObject(k, v, name);
                    removeEntriesObjArray.push(removeEntryObj);
                  };
                }
              }
              if (changedData.paymentTypes[payIdx].emailContactId !== undefined && changedData.paymentTypes[payIdx].emailContactId.length > 0) {
                for (let emailItem of changedData.paymentTypes[payIdx].emailContactId) {
                  for (let [ek, ev] of Object.entries(emailItem)) {
                    if (this.props._dropDownDataSourceMap.has(ek)) {
                      if (ev && ev.trim() !== "") {
                        let removeEntryObj = this.getDropDownRemoveObject(ek, ev, 'emailContactId');
                        removeEntriesObjArray.push(removeEntryObj);
                      };
                    }
                  }
                }
              }
              if (removeEntriesObjArray.length > 0) {
                this.props.updateDisabledOptionArray({ removeItems: removeEntriesObjArray })
              }
              changedData.paymentTypes = changedData.paymentTypes.filter((remPaymt, idx) => idx !== payIdx);
            }
          } else {
            let payObject = {
              ['name']: itemLabelObject.name,
              ['value']: itemLabelObject.id
            };
            changedData.paymentTypes.push({ paymentType: payObject });
          }
        } else if ((name === 'eChannel' || name === 'other') && taxonomyParent === 'reportFormats') {
          propsGroupPosition = 9;
          let itemLabelObj = this.getLabelFromTaxonomy(taxonomyParent + ':' + name, propsGroupPosition);
          changedData = { ...this.props.formData };

          let _reportChecked = false, rptIdx;
          for (let p = 0; p < this.props.formData.reportFormats.length; p++) {
            if (this.props.formData.reportFormats[p].value === itemLabelObj.id) {
              _reportChecked = true;
              rptIdx = p;
              break;
            }
          }

          if (_reportChecked) {
            if (e.target.checked) {
              changedData.reportFormats[rptIdx] = { ['name']: itemLabelObj.name, ['value']: itemLabelObj.id };
            } else {
              //Put logic here to remove disabled eChannel options from disabledOptionArray of eChannel
              if (name === 'eChannel' && changedData.echannelId && typeof changedData.echannelId === 'string' && changedData.echannelId.trim() !== "") {
                // let removeEntriesObjArray = [];
                // let removeEntryObj = this.getDropDownRemoveObject('echannelId',changedData.echannelId,name);
                // removeEntriesObjArray.push();
                this.props.updateDisabledOptionArray({ removeItems: [this.getDropDownRemoveObject('echannelId', changedData.echannelId, name)] });
                delete changedData.echannelId;
              }
              if (name === 'other' && changedData.otherReportFormat && typeof changedData.otherReportFormat === "string") {
                delete changedData.otherReportFormat;
              }

              changedData.reportFormats = changedData.reportFormats.filter((rptItem, idx) => idx !== rptIdx);
            }
          } else {
            changedData.reportFormats.push({ ['name']: itemLabelObj.name, ['value']: itemLabelObj.id });
          }
        } else if (name === "autoPayElectonic" || name === "autoPayCredit" || name === "autoPayStatistics") {
          propsGroupPosition = 9;
          let itemLabelRptObj = this.getLabelFromTaxonomy(taxonomyParent + ':' + name, propsGroupPosition);
          changedData = { ...this.props.formData };

          let _reportNameChecked = false, rptNameIdx;
          for (let p = 0; p < this.props.formData.reportNames.length; p++) {
            if (this.props.formData.reportNames[p].reportName.value === itemLabelRptObj.id) {
              _reportNameChecked = true;
              rptNameIdx = p;
              break;
            }
          }

          if (_reportNameChecked) {
            if (e.target.checked) {
              changedData.reportNames[rptNameIdx].reportName = { ['name']: itemLabelRptObj.name, ['value']: itemLabelRptObj.id };
              changedData.reportNames[rptNameIdx].selectedDeliveryMethods = []
            } else {
              changedData.reportNames = changedData.reportNames.filter((rptItem, idx) => idx !== rptNameIdx);
            }
          } else {
            let rptNameObject = {
              ['name']: itemLabelRptObj.name,
              ['value']: itemLabelRptObj.id
            };
            changedData.reportNames.push({ reportName: rptNameObject, selectedDeliveryMethods: [] });
          }
        } else if (name === "hsbcNet" || name === "hsbcConnect" || name === "postCourier") {
          propsGroupPosition = 9;
          let taxonomyParentArray = taxonomyParent.split('-');
          let itemLabelDlvrRptObj = this.getLabelFromTaxonomy(taxonomyParent + ':' + name, propsGroupPosition);
          changedData = { ...this.props.formData };

          let _reportDelvrChecked = false, rptDelvrIdx, rptDelvrNameIdx;

          for (let p = 0; p < this.props.formData[taxonomyParentArray[0]].length; p++) {
            let rptDlvrTyp = this.props.formData[taxonomyParentArray[0]][p].reportName.value.split(':');
            if (rptDlvrTyp[rptDlvrTyp.length - 2] === taxonomyParentArray[1]) {
              let jctr = 0;
              rptDelvrIdx = p;
              for (let delvrItem of this.props.formData[taxonomyParentArray[0]][p].selectedDeliveryMethods) {
                let delvrItemArr = delvrItem.value.split(':');
                if (delvrItemArr[delvrItemArr.length - 2] === name) {
                  _reportDelvrChecked = true;
                  rptDelvrNameIdx = jctr;
                  break;
                }
                jctr++;
              }
            }
            if (_reportDelvrChecked) {
              break;
            }
          }

          if (_reportDelvrChecked) {
            if (e.target.checked) {
              changedData.reportNames[rptDelvrIdx].selectedDeliveryMethods[rptDelvrNameIdx] = { ['name']: itemLabelDlvrRptObj.name, ['value']: itemLabelDlvrRptObj.id };
            } else {
              changedData.reportNames[rptDelvrIdx].selectedDeliveryMethods = changedData.reportNames[rptDelvrIdx].selectedDeliveryMethods.filter((rptItem, idx) => idx !== rptDelvrNameIdx);
            }
          } else {
            let rptDelvrObject = {
              ['name']: itemLabelDlvrRptObj.name,
              ['value']: itemLabelDlvrRptObj.id
            };
            changedData.reportNames[rptDelvrIdx].selectedDeliveryMethods.push(rptDelvrObject);
          }
        } else if ((name === 'hsbcNetFile' || name === "hsbcNetACH" || name === 'hostToHost' || name === 'hsbcFile' || name === 'swift') && taxonomyParent === 'echannels') {
          propsGroupPosition = 9;
          let itemLabelObj = this.getLabelFromTaxonomy(taxonomyParent + ':' + name, propsGroupPosition);
          changedData = { ...this.props.formData };

          let _echannelChecked = false, echIdx;
          for (let p = 0; p < this.props.formData.echannels.length; p++) {
            if (this.props.formData.echannels[p].value === itemLabelObj.id) {
              _echannelChecked = true;
              echIdx = p;
              break;
            }
          }

          if (_echannelChecked) {
            if (e.target.checked) {
              changedData.echannels[echIdx] = { ['name']: itemLabelObj.name, ['value']: itemLabelObj.id };
            } else {
              //Put logic here to remove disabled eChannel options from disabledOptionArray of eChannel
              changedData.echannels = changedData.echannels.filter((echItem, idx) => idx !== echIdx);
            }
          } else {
            changedData.echannels.push({ ['name']: itemLabelObj.name, ['value']: itemLabelObj.id });
          }

        } else if (name === "cannedReport" || name === "dataFeedReport" || name === 'txt' || name === 'xls') {
          propsGroupPosition = 9;
          let taxonomyParentArray = taxonomyParent.split('-');
          let containParent;
          if (name === "cannedReport" || name === "dataFeedReport") {
            containParent = 'reportType'
          } else if (name === 'txt' || name === 'xls') {
            containParent = 'reportFormat'
          }
          let subMethRpt = this.getLabelFromTaxonomy(taxonomyParent + ':' + name, propsGroupPosition);
          changedData = { ...this.props.formData };
          let _isReportChecked = false, submisIdx, rptidx = -1, rptFmtidx;

          for (let r = 0; r < this.props.formData.submissionMethods.length; r++) {
            let rptMethod = this.props.formData.submissionMethods[r].reportDeliveryAndFormat;
            submisIdx = r;
            for (let rpt = 0; rpt < rptMethod.length; rpt++) {
              let _rptMethodValue;
              rptidx = rpt
              if (containParent === 'reportType' && this.props.formData['submissionMethods'][r].submissionMethod.value.split(':')[10] === 'submissionMethodA') {
                _rptMethodValue = rptMethod[rpt].reportType.value
                if (_rptMethodValue === subMethRpt.id) {
                  _isReportChecked = true;
                  break;
                }
              } else if (containParent === 'reportFormat' && this.props.formData['submissionMethods'][r].submissionMethod.value.split(':')[10] === 'submissionMethodB') {
                _rptMethodValue = rptMethod[rpt].reportFormat;
                for (let rptCked = 0; rptCked < _rptMethodValue.length; rptCked++) {
                  if (_rptMethodValue[rptCked].value === subMethRpt.id) {
                    _isReportChecked = true;
                    rptFmtidx = rptCked;
                    break;
                  }
                }
                if (_isReportChecked) {
                  break;
                }
              }
            }
            let subMethType = this.props.formData.submissionMethods[r].submissionMethod.value.split(':');

            if ((name === "cannedReport" || name === "dataFeedReport") && (subMethType[subMethType.length - 2] === 'submissionMethodA')) {
              break;
            } else if ((name === "txt" || name === "xls") && (subMethType[subMethType.length - 2] === 'submissionMethodB')) {
              if (this.props.formData.submissionMethods[submisIdx].reportDeliveryAndFormat.length === 0) {
                rptidx = -1;
                break;
              } else {
                break;
              }

            }
          }

          if (_isReportChecked) {
            if (containParent === 'reportType') {
              changedData.submissionMethods[submisIdx].reportDeliveryAndFormat = changedData.submissionMethods[submisIdx].reportDeliveryAndFormat.filter((rptItem, idx) => idx !== rptidx);
            } else if (containParent === 'reportFormat') {
              changedData.submissionMethods[submisIdx].reportDeliveryAndFormat[0][containParent] = changedData.submissionMethods[submisIdx].reportDeliveryAndFormat[0][containParent].filter((item, index) => index !== rptFmtidx);
            }
          }
          else {
            let _rptObject = {
              ['name']: subMethRpt.name,
              ['value']: subMethRpt.id
            };
            if (containParent === 'reportFormat') {
              let tempRpt;
              if (rptidx === -1) {
                tempRpt = [];
                _rptObject = [...tempRpt, _rptObject];
                changedData.submissionMethods[submisIdx].reportDeliveryAndFormat.push({ [containParent]: _rptObject });
              } else {
                changedData.submissionMethods[submisIdx].reportDeliveryAndFormat[rptidx].reportFormat.push(_rptObject);
              }
            } else {
              changedData.submissionMethods[submisIdx].reportDeliveryAndFormat.push({ [containParent]: _rptObject });
            }
          }

        } else if (name === 'submissionMethodA' || name === 'submissionMethodB') {
          propsGroupPosition = 9;
          let taxonomyParentArray = taxonomyParent.split('-');
          let subMeth = this.getLabelFromTaxonomy(taxonomyParent + ':' + name, propsGroupPosition);
          changedData = { ...this.props.formData };
          let _subMethodChecked = false, rptIdx;

          let _submissionChecked = false, subIdx;
          for (let s = 0; s < this.props.formData.submissionMethods.length; s++) {
            if (this.props.formData.submissionMethods[s].submissionMethod.value === subMeth.id) {
              _submissionChecked = true;
              subIdx = s;
              break;
            }
          }
          if (_submissionChecked) {
            if (e.target.checked) {
              changedData.submissionMethods[subIdx] = { submissionMethod: { ['name']: subMeth.name, ['value']: subMeth.id }, submissionAccounts: [], reportDeliveryAndFormat: [] };
            } else {
              let methShortHand;
              if (changedData.submissionMethods[subIdx]['submissionAccounts'] && changedData.submissionMethods[subIdx]['submissionAccounts'].length > 0) {
                let _currMethod = subMeth.id.split(':');
                if (_currMethod[_currMethod.length - 2] === "submissionMethodA") {
                  methShortHand = 'A';
                } else if (_currMethod[_currMethod.length - 2] === "submissionMethodB") {
                  methShortHand = 'B';
                }
                let _emptyListObj = {
                  type: 'emptyListOperation',
                  disableKey: `submissionAccounts${methShortHand}availableAccounts`,
                }
                this.props.updateDisabledOptionArray(_emptyListObj);
              }
              changedData.submissionMethods = changedData.submissionMethods.filter((subItem, idx) => idx !== subIdx);
            }
          }
          else {
            changedData.submissionMethods.push({ submissionMethod: { ['name']: subMeth.name, ['value']: subMeth.id }, submissionAccounts: [], reportDeliveryAndFormat: [] });
          }
        } else if ((name === 'psc1' || name === 'psc2' || name === 'ac1' || name === 'ac2' || name === 'other') && taxonomyParent === 'primaryAndAditionalUserTraining') {
          propsGroupPosition = 9;
          let itemLabelObj = this.getLabelFromTaxonomy(taxonomyParent + ':' + name, propsGroupPosition);
          changedData = { ...this.props.formData };

          let _userTrainChecked = false, userTrainIdx;
          for (let p = 0; p < this.props.formData.primaryAndAditionalUserTraining.length; p++) {
            if (this.props.formData.primaryAndAditionalUserTraining[p].value === itemLabelObj.id) {
              _userTrainChecked = true;
              userTrainIdx = p;
              break;
            }
          }

          if (_userTrainChecked) {
            if (e.target.checked) {
              changedData.primaryAndAditionalUserTraining[userTrainIdx] = { ['name']: itemLabelObj.name, ['value']: itemLabelObj.id };
            } else {
              //Put logic here to remove disabled eChannel options from disabledOptionArray of eChannel
              if (name === 'other' && changedData.otherUserTraining && changedData.otherUserTraining instanceof Array && changedData.otherUserTraining.length > 0) {
                let removeEntriesObjArray = [];
                for (let otherUserTran of changedData.otherUserTraining) {
                  for (let [k, v] of Object.entries(otherUserTran)) {
                    if (this.props._dropDownDataSourceMap.has(k)) {
                      if (v && v.trim() !== "") {
                        let removeEntryObj = this.getDropDownRemoveObject(k, v, 'otherUserTraining');
                        removeEntriesObjArray.push(removeEntryObj);
                      };
                    }
                  }
                }
                if (removeEntriesObjArray.length > 0) {
                  this.props.updateDisabledOptionArray({ removeItems: removeEntriesObjArray })
                }
                changedData.otherUserTraining.length = 0;
              }

              changedData.primaryAndAditionalUserTraining = changedData.primaryAndAditionalUserTraining.filter((userItem, idx) => idx !== userTrainIdx);
            }
          } else {
            changedData.primaryAndAditionalUserTraining.push({ ['name']: itemLabelObj.name, ['value']: itemLabelObj.id });
          }
        } else if (name === 'confirm') {
          propsGroupPosition = 9;
          let confirmLabelObj = this.getLabelFromTaxonomy(taxonomyParent + ':' + name, propsGroupPosition);
          changedData = { ...this.props.formData };
          let _dataConfirmation = false;
          if (this.props.formData.dataConfirmation && Object.keys(this.props.formData.dataConfirmation).length > 1 && this.props.formData.dataConfirmation.value === confirmLabelObj.id) {
            _dataConfirmation = true;
          }

          if (_dataConfirmation) {
            if (e.target.checked) {
              changedData.dataConfirmation = { ['name']: confirmLabelObj.name, ['value']: confirmLabelObj.id };
            } else {
              if (changedData.dataConfirmation) {
                delete changedData.dataConfirmation;
              }
            }
          } else {
            changedData.dataConfirmation = { ['name']: confirmLabelObj.name, ['value']: confirmLabelObj.id };
          }
        } else if ((name === 'CCCentralPay' || name === 'VCCentralPay' || name === 'PCCentralPay' || name === 'CCIndividualPay' || name === 'CCIndividualBillCPay' || name === 'LodgeCardCentralPay' || name === 'FuelCardCentralPay') && taxonomyParent === 'currencyType') {
          propsGroupPosition = 9;
          let itemLabelObj = this.getLabelFromCard(taxonomyParent + ':' + name, propsGroupPosition);
          changedData = { ...this.props.formData };
          let _cardChecked = false, rptIdx, pos;
          let arr = itemLabelObj.find(item => item.id === currId);
          if (this.props.formData !== undefined) {
            for (let p = 0; p < this.props.formData.currencyType.length; p++) {
              if (this.props.formData.currencyType[p].value === currId) {
                _cardChecked = true;
                rptIdx = p;
                break;
              }
            }
            if (_cardChecked) {
              if (e.target.checked) {
                changedData.currencyType[rptIdx] = { ['name']: arr.name, ['value']: arr.id };
              } else {
                changedData.currencyType = changedData.currencyType.filter((rptItem, idx) => rptItem.value !== currId);
              }
            } else {
              changedData.currencyType.push({ ['name']: arr.name, ['value']: arr.id });
            }
          }

        } else if ((name === 'b2bSolution') && taxonomyParent === 'b2bSolution') {
          changedData = { ...this.props.formData };
          let _b2bSolution = this.props.formData.b2bSolution;
          changedData.b2bSolution = !_b2bSolution
          if (changedData.b2bSolution === false) {
            changedData.paymentFacilitatorName = '';
            changedData.merchantIdentificationNumber = '';
            changedData.purposeOfCardPayment = '';
            changedData.supplierNameLst = [];
            changedData.supplierNameLst1 = null;
            changedData.supplierNameLst2 = null;
            changedData.supplierNameLst3 = null;
            changedData.supplierNameLst4 = null;
            changedData.supplierNameLst5 = null;
          }
        } else if (name === 'specificDetailsMandatoryCheck') {
          changedData = { ...this.props.formData };
          let _specificDetailsMandatoryCheck = this.props.formData.specificDetailsMandatoryCheck;
          changedData.specificDetailsMandatoryCheck = !_specificDetailsMandatoryCheck

        } else if (name === 'addressAndContactMandatoryCheck') {
          changedData = { ...this.props.formData };
          let _addressAndContactMandatoryCheck = this.props.formData.addressAndContactMandatoryCheck;
          changedData.addressAndContactMandatoryCheck = !_addressAndContactMandatoryCheck
        }
      }
      else {
        let _isNewDataAdd = false;
        changedData = JSON.parse(JSON.stringify(this.props.formData));
        if (orderChain.length === 0) {
          if (name === "isReportingRequired") {
            if (!value) {
              if (changedData.echannelId && typeof changedData.echannelId === 'string' && changedData.echannelId.trim() !== "") {
                let removeEntriesObjArr = [];
                let removeEntryObj = this.getDropDownRemoveObject('echannelId', changedData.echannelId, 'eChannel');
                removeEntriesObjArr.push(removeEntryObj);
                this.props.updateDisabledOptionArray({ removeItems: removeEntriesObjArr });

              }
              if (changedData.echannelId) {
                delete changedData.echannelId;
              }
              if (changedData.otherReportFormat) {
                delete changedData.otherReportFormat
              }
              if (changedData.reportFormats) {
                changedData.reportFormats.length = 0;
              }
              changedData[name] = value;
              // changedData = {[name]:value,['reportFormats']:[],['reportNames']:[]}
            } else {
              changedData = { ...changedData, [name]: value }
            }
          } else {
            changedData = { ...changedData, [name]: value }
          }
        } else {
          _changedValue = changedData[orderChain[0]]
          for (let k = 1; k < orderChain.length; k++) {
            if (orderChain[k] == -1) {
              _isNewDataAdd = true;
              break;
            }
            _changedValue = _changedValue[orderChain[k]];
          };
          if (_isNewDataAdd || (value instanceof Array && typeof _changedValue === 'object')) {
            if (_isNewDataAdd) {
              _changedValue.push({ [name]: value });
            } else {
              if ((value instanceof Array) && (typeof _changedValue === 'object') && !_isNewDataAdd) {
                _changedValue[name] = value;
              }
            }
          } else {
            if (!changedData[name]) {
              changedData = { ...changedData, [name]: value }
            }
          }
        }
      }
    }
    this.props.onChange(changedData);
  }

  getDropDownRemoveObject = (dropDownName, currVal = "", parentKeyName) => {
    let _dropDownOptionsSourceKey = this.props._dropDownDataSourceMap.get(dropDownName);
    let ddEntryRemove = {
      currentValue: currVal,
      updateValue: undefined,
      dataSourceKey: _dropDownOptionsSourceKey,
      disbaledOptionKey: parentKeyName + _dropDownOptionsSourceKey
    };
    return ddEntryRemove;
  }

  getAggregateFormComponents = (value) => {
    let _formComponents;
    if (value) {
      _formComponents = JSON.parse(Translations(value, this.props.lang, this.props.translatedData) || JSON.stringify(value));
    } else {
      _formComponents = [];
    }
    return _formComponents;
  }

  handleDelete = (itemData) => e => {
    this.props.updateDisabledOptionArray(itemData);
    // console.log('After aggregate delete props: ',this.props);
    // this.props.onChange(changedFormData);
  }

  handleAddAggregateForm = (orderChain = [], props) => (e) => {
    let _currComponentVal = this.selectValueForComposedComponent(orderChain, props);
    if (_currComponentVal && _currComponentVal.length === 0)
      return null
    let formComponents = this.getAggregateFormComponents(props.components);
    if (this.checkAggregateFormAddition(formComponents, _currComponentVal[_currComponentVal.length - 1])
      && this.checkForAggregateBoxCount(props.name, _currComponentVal.length)) {
      let cpyFormData = JSON.parse(JSON.stringify(this.props.formData));
      let tempDataPointer = cpyFormData;
      for (let item of orderChain) {
        tempDataPointer = tempDataPointer[item];
      }
      if (tempDataPointer[props.name] instanceof Array) {
        tempDataPointer[props.name].push({});
      }
      // let addButtonFormData = { ...this.props.formData,[props.name]: [...this.props.formData[props.name],{}] };
      this.props.onChange(cpyFormData);
    }
  }

  checkForAggregateBoxCount = (aggBoxName, currCount) => {
    let aggBoxLimit = getAggregateBoxMaxCount(aggBoxName);
    if (aggBoxLimit === -1) {
      return true
    } else {
      return aggBoxLimit > currCount ? true : false;
    }
  }

  checkAggregateFormAddition = (aggFormItems, lastArrObject) => {
    if (Object.keys(lastArrObject).length === 0)
      return false;
    else {
      let mandatoryItems = [];
      for (let item of aggFormItems) {
        for (let [k, v] of Object.entries(item)) {
          if (k === 'mandatory' && true === JSON.parse(v)) {
            mandatoryItems.push(item.name);
            break;
          }
        }
      }
      for (let objKey of Object.keys(lastArrObject)) {
        mandatoryItems = mandatoryItems.filter(item => item != objKey || (item === objKey && lastArrObject[objKey].trim() === ""));
        if (mandatoryItems.length <= 0) {
          break;
        }
      }
      if (mandatoryItems.length <= 0)
        return true;
      else
        return false;
    }
  }

  getAggregateFormBox = (props, _partialJsx, i, orderChain = []) => {
    let deleteObject, _addButtonJsx, contentMainClass, componentMainClass, deleteButtonClass, _selectedValue;
    let nameHierarchy = orderChain.length > 0 ? orderChain.join('-') + '-' + props.name : props.name;
    if (i > 0) {//Prepare an object to remove the aggregate form data on delete
      deleteObject = {
        idx: i,
        type: 'removeAggregateForm',
        name: nameHierarchy,
        accordionName: this.props.name
      }
    };

    _selectedValue = this.selectValueForComposedComponent(orderChain, props);
    let formComp = this.getAggregateFormComponents(props.components);
    if ((i === _selectedValue.length - 1)
      && (props.addItemButton)
      && this.checkAggregateFormAddition(formComp, _selectedValue[_selectedValue.length - 1])
      && this.checkForAggregateBoxCount(props.name, _selectedValue.length)
    ) {
      _addButtonJsx = (
        <button
          key={props.name + i + '_add_item'}
          onClick={this.handleAddAggregateForm(orderChain, props)}
          className={classnames("gdocs-btn-default", { "gdocs-mb16": props.name === "contactId" })}
        >
          {(Translations(props.addItemButton, this.props.lang, this.props.translatedData) || `+ Add Item`) + " " + (_selectedValue.length + 1)}
        </button>
      )
    }

    contentMainClass = classnames({
      "multiple-aggregate-form-box-content-div": props.addItemButton && orderChain.length <= 0 ? true : false,
      "multiple-embedded-aggregate-form-box-content-div": props.addItemButton && orderChain.length > 0 ? true : false,
      "single-aggregate-form-box-content-div": props.addItemButton ? false : true
    });
    componentMainClass = classnames({
      "multiple-aggregate-form-box-components-div": props.addItemButton && orderChain.length <= 0 ? true : false,
      "multiple-embedded-aggregate-form-box-components-div": props.addItemButton && orderChain.length > 0 ? true : false,
      "single-aggregate-form-box-components-div": props.addItemButton ? false : true
    });
    deleteButtonClass = classnames({
      "delete-aggregate-form-box": i > 0 ? true : false,
      "delete-aggregate-form-margin": i <= 0 ? true : false
    })

    return (
      <div className="aggregate-form-box-inner-div" key={props.name + '_aggregate_form_' + i}>
        <div className={contentMainClass}>
          <div className={componentMainClass}>
            {_partialJsx}
          </div>
          {i > 0 ?
            <div
              key={props.name + '_' + i}
              className={deleteButtonClass}
              onClick={this.handleDelete(deleteObject)}
            >
              <i tabIndex={0} className="icon icon-bin"></i>
            </div>
            :
            null
          }
        </div>
        {_addButtonJsx || ''}
      </div>
    );
  }

  persistData = (e) => {
    //console.log('Object returned before persistence is :',e);
    this.props._saveStateToSessionOnEdit();
    this.props.history.push(e[0].editLink + e[0].id);
    localStorage.setItem(this.props.name, JSON.stringify(this.props.formData));
  }

  submitFormData = () => {
    this.props._submitTabdata({ [this.props.name]: this.props.formData });
  }

  selectValueForSimpleComponent = (orderChain = [], props) => {
    let _selectedValue;
    if (orderChain.length <= 0) {
      if (this.props.formData[props.name]
        && typeof this.props.formData[props.name] === 'object'
        && !(this.props.formData[props.name] instanceof Array)
      ) {
        _selectedValue = this.props.formData[props.name]['value'] || '';
      } else {
        if (typeof this.props.formData[props.name] === 'boolean') {
          _selectedValue = JSON.parse(this.props.formData[props.name]);
        } else {
          _selectedValue = this.props.formData[props.name] || '';
        }
      }
    } else {
      _selectedValue = this.props.formData[orderChain[0]];
      for (let r = 1; r < orderChain.length; r++) {
        if (orderChain[r] == -1) {
          break;
        }
        _selectedValue = _selectedValue[orderChain[r]] || '';
      }
      if (typeof _selectedValue === 'object' && _selectedValue[props.name] === undefined) {
        _selectedValue = _selectedValue.value || ''
      } else {
        if (_selectedValue && _selectedValue[props.name] && typeof _selectedValue[props.name] === 'object') {
          _selectedValue = _selectedValue[props.name]['value'] || '';
        } else {
          _selectedValue = _selectedValue && _selectedValue[props.name] || '';
        }
      }
    }
    return _selectedValue;
  }

  selectValueForComposedComponent = (orderChain = [], props) => {
    let _selectedValue;
    if (orderChain.length <= 0) {
      _selectedValue = this.props.formData[props.name] || [];
    } else {
      _selectedValue = this.props.formData[orderChain[0]];
      for (let r = 1; r < orderChain.length; r++) {
        if (orderChain[r] == -1) {
          break;
        }
        _selectedValue = _selectedValue[orderChain[r]];
      }
      if (_selectedValue[props.name] === undefined) {
        _selectedValue[props.name] = [];
      }
      _selectedValue = _selectedValue[props.name];
    }
    return _selectedValue;
  }

  getLabelFromTaxonomy = (propIdentifier, propGrpPosition = 9) => {
    let taxonomyItem = {}, accordionTaxonomyIdx = 8;
    let propsGroup = propIdentifier.split(':')[0].split('-');
    let propsName = propIdentifier.split(':')[1];

    let _taxonomyNodeArray = this.props._checkboxTaxonomy ? this.props._checkboxTaxonomy.classificationNodes : [];
    if (_taxonomyNodeArray !== undefined && _taxonomyNodeArray.length > 0) {
      for (let q = 0; q < propsGroup.length; q++) {
        propGrpPosition = +propGrpPosition + q;

        _taxonomyNodeArray = this.getAssociationArrayFromTaxonomy(this.props.name, _taxonomyNodeArray, propsGroup[q], propGrpPosition);
      }

      for (let node of _taxonomyNodeArray) {
        let nodeSplitArr = node.id.split(':');
        if (nodeSplitArr[accordionTaxonomyIdx] === this.props.name && nodeSplitArr[propGrpPosition] === propsGroup[propsGroup.length - 1]) {
          if (nodeSplitArr[nodeSplitArr.length - 2] === propsName) {
            taxonomyItem.id = node.id;
            taxonomyItem.name = node.name || 'Unlabelled Checkbox';
            taxonomyItem.tooltip = node.tooltip || undefined;
            break;
          }
        }
      }
    }
    return taxonomyItem;

  }

  getAssociationArrayFromTaxonomy = (accName, nodeArray, identifierKey, keyPos) => {
    let retNodeArr = [];
    if (nodeArray !== undefined) {
      for (let nodeItem of nodeArray) {
        if (nodeItem.id.split(':')[8] === accName && nodeItem.id.split(':')[keyPos] === identifierKey) {
          retNodeArr = nodeItem.associations;
          break;
        }
      }
      return retNodeArr;

    }
  }

  getLabelFromCard = (propIdentifier, propGrpPosition = 9) => {
    let taxonomyItem = [], accordionTaxonomyIdx = 8;
    let propsGroup = propIdentifier.split(':')[0].split('-');
    let propsName = propIdentifier.split(':')[1];
    let _taxonomyNodeArray = this.props._checkboxTaxonomy ? this.props._checkboxTaxonomy.associations : [];

    for (let q = 0; q < propsGroup.length; q++) {
      propGrpPosition = +propGrpPosition + q;
      _taxonomyNodeArray = this.getAssociationArrayCard(propsName, _taxonomyNodeArray, propsGroup[q], propGrpPosition);
    }

    for (let node of _taxonomyNodeArray) {
      let nodeSplitArr = node.id.split(':');
      if (nodeSplitArr[propGrpPosition] === propsName && nodeSplitArr[accordionTaxonomyIdx] === 'cardType') {

        if (nodeSplitArr[nodeSplitArr.length - 2] === propsName) {
          taxonomyItem = _taxonomyNodeArray;
          taxonomyItem = taxonomyItem.map(item => {
            return {
              id: item.id,
              name: item.name,
              _isChecked: this.isCheckboxChecked(propsGroup, propsName, item.id)
            }
          });
        }
      }
    }
    return taxonomyItem;
  }

  isCheckboxChecked = (propsGroup, propsName, id) => {
    for (let rptItem of this.props.formData[propsGroup]) {
      let rptType = rptItem.value.split(':');
      if (rptType[rptType.length - 2] === propsName && rptItem.value === id) {
        return true;
      }
    }
  }

  getAssociationArrayCard = (accName, nodeArray, identifierKey, keyPos) => {
    let retNodeArr = [];
    for (let nodeItem of nodeArray) {
      if (nodeItem.id.split(':')[8] === 'cardType' && nodeItem.id.split(':')[keyPos] === accName) {
        retNodeArr = nodeItem.associations;
        break;
      }
    }
    return retNodeArr;
  }

  getLabelFromCard1 = (propIdentifier, propGrpPosition = 9) => {
    let taxonomyItem = [], accordionTaxonomyIdx = 8;
    let propsGroup = propIdentifier.split(':')[0].split('-');
    let propsName = propIdentifier.split(':')[1];
    let _taxonomyNodeArray = this.props._checkboxTaxonomy ? this.props._checkboxTaxonomy.associations : [];

    for (let q = 0; q < propsGroup.length; q++) {
      propGrpPosition = +propGrpPosition + q;
      _taxonomyNodeArray = this.getAssociationArrayCard1(propsName, _taxonomyNodeArray, propsGroup[q], propGrpPosition);
    }

    for (let node of _taxonomyNodeArray) {
      let nodeSplitArr = node.id.split(':');
      if ((nodeSplitArr[propGrpPosition] === propsName) && nodeSplitArr[accordionTaxonomyIdx] === 'cardType') {

        // if (nodeSplitArr[nodeSplitArr.length - 1] === propsName) {
        taxonomyItem = _taxonomyNodeArray;
        taxonomyItem = taxonomyItem.map(item => {
          return {
            id: item.id,
            name: item.name,
            currency: item.associations,
            _isChecked: this.isCheckboxChecked1(propsGroup, nodeSplitArr[propGrpPosition], item.id),
            propsName: nodeSplitArr[10],
            props: 'currencyType',
            isDisabled: true
          }
        });
        // }
      }
    }
    for (let index = 0; index < taxonomyItem.length; index++) {
      if (taxonomyItem[index]._isChecked === true) {
        taxonomyItem = taxonomyItem.map(item => {
          return {
            id: item.id,
            name: item.name,
            currency: item.currency,
            _isChecked: item._isChecked,
            propsName: item.propsName,
            props: item.props,
            isDisabled: false
          }
        });
        break;
      }
    }
    return taxonomyItem;
  }

  isCheckboxChecked1 = (propsGroup, propsName, id) => {
    for (let rptItem of this.props.formData[propsGroup]) {
      if (rptItem !== undefined && rptItem.value !== undefined) {
        let rptType = rptItem.value.split(':');
        if (rptType[rptType.length - 2] === propsName && rptItem.value === id) {
          return true;
        }
      }
    }
  }

  getAssociationArrayCard1 = (accName, nodeArray, identifierKey, keyPos) => {
    let retNodeArr = [];
    for (let nodeItem of nodeArray) {
      if (nodeItem.id.split(':')[8] === 'cardType' && nodeItem.id.split(':')[keyPos] === accName) {
        retNodeArr = nodeItem.associations;
        break;
      }
    }
    return retNodeArr;
  }

  getPaymentLabel = (propIdentifier, propGrpPosition = 9) => {
    let card = {}, accordionTaxonomyIdx = 8;
    let propsGroup = propIdentifier.split(':')[0].split('-');
    let propsName = propIdentifier.split(':')[1];
    let _taxonomyNodeArray = this.props._checkboxTaxonomy ? this.props._checkboxTaxonomy.associations : [];

    for (let node of _taxonomyNodeArray) {
      let nodeSplitArr = node.id.split(':');
      if (nodeSplitArr[propGrpPosition] === propsName && nodeSplitArr[accordionTaxonomyIdx] === 'cardType') {
        card.name = node.name || 'Unlabelled Checkbox';
        break;
      }
    }
    return card;
  }

  getPaymentLabel1 = (propIdentifier, propGrpPosition = 9) => {
    let card = {}, accordionTaxonomyIdx = 8;
    let propsGroup = propIdentifier.split(':')[0].split('-');
    let propsName = propIdentifier.split(':')[1];
    let _taxonomyNodeArray = this.props._checkboxTaxonomy ? this.props._checkboxTaxonomy.associations : [];

    for (let node of _taxonomyNodeArray) {
      let nodeSplitArr = node.id.split(':');
      if (nodeSplitArr[propGrpPosition] === propsName && nodeSplitArr[accordionTaxonomyIdx] === 'cardType') {
        // if (nodeSplitArr[accordionTaxonomyIdx] === 'cardType') {

        card.name = node.name || 'Unlabelled Checkbox';
        break;
      }
    }
    return card;
  }

  handleCardType = (name, orderChain, taxonomyChain = '', cardId) => e => {
    let value, _changedValue;
    let changedData;
    if (e.target && e.target.checked !== undefined) {
      let propsGroupPosition;
      let taxonomyParent = taxonomyChain;
      propsGroupPosition = 9;
      let itemLabelObj = this.getLabelFromCard1(taxonomyParent + ':' + name, propsGroupPosition);
      changedData = { ...this.props.formData };
      let _cardChecked = false, rptIdx, pos;
      let arr = itemLabelObj.find(item => item.id === cardId);
      if (this.props.formData !== undefined) {
        for (let p = 0; p < this.props.formData.cardType.length; p++) {
          if (this.props.formData.cardType[p].value === cardId) {
            _cardChecked = true;
            rptIdx = p;
            break;
          }
        }
        if (_cardChecked) {
          if (e.target.checked) {
            changedData.cardType[rptIdx] = { ['name']: arr.name, ['value']: arr.id };
          } else {
            changedData.cardType = changedData.cardType.filter((rptItem, idx) => rptItem.value !== cardId);
          }
        } else {
          changedData.cardType.push({ ['name']: arr.name, ['value']: arr.id });
        }
      }
    }
    if (changedData.cardType.length === 0) {
      changedData.currencyType = [];
    }
    if (changedData.cardType.length > 0) {
      let splitArr = [];
      for (const item of changedData.cardType) {
        let rptType = item.value.split(':');
        splitArr.push(rptType[rptType.length - 2])
      }
      let val = splitArr.find(x => x === name);
      if (val === undefined) {
        if (changedData.currencyType !== undefined && changedData.currencyType.length !== 0) {
          let currArr = changedData.currencyType;
          let arrEle = [];
          for (let i = 0; i < currArr.length; i++) {
            let rptType = currArr[i].value.split(':');
            if (rptType[rptType.length - 2] === name) {
              arrEle.push(currArr[i])
            }
          }
          let difference = currArr.filter(val => !arrEle.includes(val));
          changedData.currencyType = difference;
        }

      }
    }
    this.props.onChange(changedData);
  }


  handleCurrencyType = (name, orderChain, taxonomyChain = '', currId, itemObj) => e => {
    let changedData;
    if (e.target && e.target.checked !== undefined) {
      let propsGroupPosition;
      propsGroupPosition = 9;
      let itemLabelObj = this.getCurrencyChecked(name, itemObj);

      changedData = { ...this.props.formData };
      if (itemLabelObj !== undefined) {
        let _cardChecked = false, rptIdx, pos;
        let arr = itemLabelObj.find(item => item.id === currId);
        if (this.props.formData !== undefined) {
          for (let p = 0; p < this.props.formData.currencyType.length; p++) {
            if (this.props.formData.currencyType[p].value === currId) {
              _cardChecked = true;
              rptIdx = p;
              break;
            }
          }
          if (_cardChecked) {
            if (e.target.checked) {
              changedData.currencyType[rptIdx] = { ['name']: arr.name, ['value']: arr.id };
            } else {
              changedData.currencyType = changedData.currencyType.filter((rptItem, idx) => rptItem.value !== currId);
            }
          } else {
            changedData.currencyType.push({ ['name']: arr.name, ['value']: arr.id });
          }
        }
        let dataArr = changedData.currencyType.map(item => {
          return [item.value, item]
        });
        let maparr = new Map(dataArr);
        let currencyType = [...maparr.values()];
        changedData.currencyType = currencyType;
        this.props.onChange(changedData);
      }
    }
  }

  getCurrencyChecked = (name, itemLabelObj) => {
    let taxonomyItem = [];
    let checkedCard = itemLabelObj.filter(x => x._isChecked === true);
    let notCheckedCard = itemLabelObj.filter(x => x._isChecked !== true);
    if (checkedCard !== undefined && checkedCard !== null && checkedCard.length !== 0) {
      taxonomyItem = itemLabelObj[0].currency;
    } else {
      taxonomyItem = itemLabelObj[0].currency;
    }
    if (taxonomyItem !== undefined) {
      for (let node of taxonomyItem) {
        let nodeSplitArr = node.id.split(':');
        let propsGroup = 'currencyType';
        if (nodeSplitArr[9] === name) {
          taxonomyItem = taxonomyItem.map(item => {
            return {
              id: item.id,
              name: item.name,
              _isChecked: this.isCurrencyChecked(propsGroup, name, item.id),
            }
          });
        }

      }
    }
    return taxonomyItem;
  }

  isCurrencyChecked = (propsGroup, propsName, id) => {
    for (let rptItem of this.props.formData[propsGroup]) {
      let rptType = rptItem.value.split(':');
      if (rptType[rptType.length - 2] == propsName && rptItem.value === id) {
        return true;
      }
    }
  }

  getAssociationsFromTaxonomy = (propIdentifier) => {
    let retAssociations = {};
    let propsGroup = propIdentifier.split(':')[0];
    let propsName = propIdentifier.split(':')[1];

    if (this.props._checkboxTaxonomy.classificationNodes) {
      for (let node of this.props._checkboxTaxonomy.classificationNodes) {
        let nodeSplitArr = node.id.split(':');
        if (nodeSplitArr[8] === this.props.name && nodeSplitArr[9] === propsGroup) {
          let associations = node.associations;
          retAssociations.associationLabel = node.name;
          if (associations && associations.length > 0) {
            retAssociations.associationArray = associations;
            break;
          }
        }
      }
    }
    return retAssociations;
  }

  findRelevantCheckBoxTaxonomyGroup = (_propName) => {
    let _relevantAvailablePriviledges = {}, _foundPrivlege = false;

    for (let _privKey of this.props.groupCheckBoxData['availablePriviledges']) {
      for (let _objKey of Object.keys(_privKey)) {
        if (_objKey === _propName) {
          _relevantAvailablePriviledges = _privKey[_objKey];
          _foundPrivlege = true;
          break;
        }
      }
      if (_foundPrivlege) {
        break;
      }
    }

    return _relevantAvailablePriviledges;
  }

  renderComponent = (componentType, elementKey, props, idx = -1, parent = '', arrIdx = -1, children = undefined, orderChain = []) => {
    let _label, _displayKey, _mandatoryMessage, _placeholder, _type, _jsx, _createLinkText, _createLink, _editable, _editLink,
      _dropDownOptionsSourceKey, _optionKey, _name, _tooltip, _inputPrefix, _selectedValue, _persistDataStore,
      _isRepeatingField = false, _allSelectorValue = undefined, _allSelectorPosition = undefined;

    let _elementKey = arrIdx !== -1 ? elementKey + '_' + arrIdx : elementKey + '_' + Math.ceil(Math.random(1000));
    switch (componentType) {
      case 'aggregateForm': {
        let _partialJsx = [], i = 0, _outerJsx = [];
        let formComponents = this.getAggregateFormComponents(props.components);

        if (parent && parent.trim() !== '') {
          let relatedNarratives = [], narrReplaced = false;
          if (this.props.paymentNarrativeMap.has(parent)) {
            relatedNarratives = this.props.paymentNarrativeMap.get(parent);
            for (let relNarItem of relatedNarratives) {
              let splitNarrItemArr = relNarItem.split('_');
              if (splitNarrItemArr.length > 1) {
                if (splitNarrItemArr[0] === props.name) {
                  relatedNarratives = splitNarrItemArr.slice(1, splitNarrItemArr.length);
                  narrReplaced = true;
                }
              }
              if (narrReplaced) {
                break;
              }
            }
          }
          formComponents = formComponents.map((mapItem, idx) => {
            if (relatedNarratives.includes(mapItem.name)) {
              if (idx > 1) {
                mapItem.title = '';
              }
              return mapItem;
            }
          });
          formComponents = formComponents.filter(item => item);
        }
        if (props.conditionalComponents) {
          let _currPaymentKey = `${this.props._selectedPaymentType || ''}_${props.name}`;
          if (this.props.paymentNarrativeMap.has(_currPaymentKey)) {
            let relevantPaymentFields = this.props.paymentNarrativeMap.get(_currPaymentKey);
            formComponents = formComponents.map((mapItem, idx) => {
              if (relevantPaymentFields.includes(mapItem.name)) {
                return mapItem;
              }
            })
              .filter(item => item);
          }
        }

        do {
          let aggregateOrderChain = [...orderChain];
          aggregateOrderChain.push(props.name);
          _partialJsx = [];

          //get the current value of the field in 'formData' object using 'orderChain'
          _selectedValue = this.selectValueForComposedComponent(orderChain, props);
          let _passParent = props.name;
          let appendMethod;
          if (props.name === 'submissionAccounts') {
            let pointerFormData = this.props.formData;
            for (let i = 0; i < orderChain.length; i++) {
              pointerFormData = pointerFormData[orderChain[i]]
            }
            let currMethod = pointerFormData.submissionMethod.value.split(':');
            if (currMethod[currMethod.length - 2] === "submissionMethodA") {
              appendMethod = 'A';
            } else if (currMethod[currMethod.length - 2] === "submissionMethodB") {
              appendMethod = 'B';
            }
            _passParent += `%${appendMethod}`;
          }
          for (let item of formComponents) {
            let ix = _selectedValue.length > 0 ? i : -1;
            aggregateOrderChain.push(ix);
            _partialJsx.push(this.renderComponent(item.fieldType, item.name + i, item, ix, _passParent, undefined, undefined, [...aggregateOrderChain]));
            aggregateOrderChain.pop();
          }
          let tempJsx = this.getAggregateFormBox(props, _partialJsx, i, orderChain);
          _outerJsx.push(tempJsx);

          i = i + 1;
        } while (i < _selectedValue.length)

        _jsx = (
          <div key={_elementKey + '_main_div'}>
            {props.title && props.title.trim() !== '' ? <b>{Translations(props.title, this.props.lang, this.props.translatedData) || ''}</b> : ''}
            {_outerJsx}
          </div>
        );

        break;
      }

      case 'button': {
        if (props.name === 'saveAndRefresh') {
          _jsx = (
            <div key={'accordionButton' + props.name + props.text} className="form-buttons-save-section">
              <div className="form-buttons-wrapper">
                <button className={props.bsClass} onClick={this.submitFormData}>
                  {Translations(props.text, this.props.lang, this.props.translatedData) || `Save Changes`}
                </button>
              </div>
            </div>
          )
        } else if (props.name === 'addAccountButton') {
          _jsx = (
            <div key={props.name}>
              <button className="gdocs-btn-default">
                {Translations(props.text, this.props.lang, this.props.translatedData) || `+ Add Item`}
              </button>
            </div>
          )
        } else if (props.name === 'addSupplier') {
          _jsx = (
            <div key={props.name} id="addSupplier">
              <button className="gdocs-btn-default" onClick={this.handleTextboxForm}>
                {Translations(props.text, this.props.lang, this.props.translatedData) || `+ Add Supplier`}
              </button>
            </div>
          )
        }
        else {
          _jsx = ''
        }

        break;
      }
      case 'checkbox': {
        let _isChecked = false, _paymentIdx = -1;
        let propsName = elementKey.split('_')[1];
        let propsGroup = props.split('-'), _propsGroupPosition = 9;
        this.setPaymentTypeForDD = propsName;
        if (propsName === 'wps' || propsName === 'spo' || propsName === 'nonWps' || propsName === 'so' || propsName === 'sp' || propsName === 'salary') {
          for (let p = 0; p < this.props.formData[propsGroup[0]].length; p++) {
            let payType = this.props.formData[propsGroup[0]][p].paymentType.value.split(':');
            if (payType[payType.length - 2] === propsName) {
              _paymentIdx = p;
              _isChecked = true;
              _propsGroupPosition = 9;
              break;
            }
          }
        } else if ((propsName === 'eChannel' || propsName === 'other') && propsGroup[0] === 'reportFormats') {
          for (let rptItem of this.props.formData[propsGroup[0]]) {
            let rptType = rptItem.value.split(':');
            if (rptType[rptType.length - 2] === propsName) {
              _isChecked = true;
              _propsGroupPosition = 9;
              break;
            }
          }
        } else if ((propsName === 'CCCentralPay' || propsName === 'VCCentralPay' || propsName === 'PCCentralPay' || propsName === 'CCIndividualPay' || propsName === 'CCIndividualBillCPay' || propsName === 'LodgeCardCentralPay' || propsName === 'FuelCardCentralPay') && propsGroup[0] === 'currencyType') {
          for (let rptItem of this.props.formData[propsGroup]) {
            let rptType = rptItem.value.split(':');
            if (rptType[rptType.length - 2] === propsName) {
              _isChecked = true;
              _propsGroupPosition = 9;
              break;
            }
          }
        } else if ((propsName === 'CorporateCard' || propsName === 'PurchasingCard' || propsName === 'VirtualCard' || propsName === 'LodgeCard' || propsName === 'OneCard' || propsName === 'FleetCard') && propsGroup[0] === 'cardType') {
          if (propsGroup !== undefined && this.props.formData[propsGroup] !== undefined) {
            for (let rptItem of this.props.formData[propsGroup]) {
              if (rptItem !== undefined && rptItem.value !== undefined) {
                let rptType = rptItem.value.split(':');
                if (rptType[rptType.length - 2] === propsName) {
                  _isChecked = true;
                  _propsGroupPosition = 9;
                  break;
                }
              }
            }
          }
        } else if (propsName === 'autoPayElectonic' || propsName === 'autoPayCredit' || propsName === 'autoPayStatistics') {
          for (let p = 0; p < this.props.formData[propsGroup[0]].length; p++) {
            let rptNameType = this.props.formData[propsGroup[0]][p].reportName.value.split(':');
            if (rptNameType[rptNameType.length - 2] === propsName) {
              _paymentIdx = p;
              _isChecked = true;
              _propsGroupPosition = 9;
              break;
            }
          }
        } else if (propsName === 'hsbcNet' || propsName === 'hsbcConnect' || propsName === 'postCourier') {
          _propsGroupPosition = 9;
          for (let p = 0; p < this.props.formData[propsGroup[0]].length; p++) {
            let rptNameTyp = this.props.formData[propsGroup[0]][p].reportName.value.split(':');
            if (rptNameTyp[rptNameTyp.length - 2] === propsGroup[1]) {
              for (let delvrItem of this.props.formData[propsGroup[0]][p].selectedDeliveryMethods) {
                let delvrItemArr = delvrItem.value.split(':');
                if (delvrItemArr[delvrItemArr.length - 2] === propsName) {
                  _isChecked = true;
                  break;
                }
              }
            }
            if (_isChecked) {
              break;
            }
          }
        } else if ((propsName === 'hsbcNetFile' || propsName === "hsbcNetACH" || propsName === 'hostToHost' || propsName === 'hsbcFile' || propsName === 'swift') && propsGroup[0] === 'echannels') {
          for (let echItem of this.props.formData[propsGroup[0]]) {
            let echType = echItem.value.split(':');
            if (echType[echType.length - 2] === propsName) {
              _isChecked = true;
              _propsGroupPosition = 9;
              break;
            }
          }
        } else if (propsName === 'submissionMethodA' || propsName === 'submissionMethodB') {
          for (let s = 0; s < this.props.formData[propsGroup[0]].length; s++) {
            let subMethod = this.props.formData[propsGroup[0]][s].submissionMethod.value.split(':');
            if (subMethod[subMethod.length - 2] === propsName) {
              _paymentIdx = s;
              _isChecked = true;
              _propsGroupPosition = 9;
              break;
            }
          }
        } else if (propsName === 'cannedReport' || propsName === 'dataFeedReport' || propsName === 'txt' || propsName === 'xls') {
          let innerParent = propsGroup[0];

          for (let r = 0; r < this.props.formData.submissionMethods.length; r++) {
            let rptMethod = this.props.formData.submissionMethods[r].reportDeliveryAndFormat;
            for (let rpt = 0; rpt < rptMethod.length; rpt++) {
              let _rptMethod;
              if (innerParent === 'reportType' && this.props.formData['submissionMethods'][r].submissionMethod.value.split(':')[10] === 'submissionMethodA') {
                _rptMethod = rptMethod[rpt][propsGroup[0]].value.split(':');
                if (_rptMethod[_rptMethod.length - 2] === propsName) {
                  _isChecked = true;
                  _propsGroupPosition = 9;
                  break;
                }
              } else if (innerParent === 'reportFormat' && this.props.formData['submissionMethods'][r].submissionMethod.value.split(':')[10] === 'submissionMethodB') {
                _rptMethod = rptMethod[rpt][propsGroup[0]];
                for (let rptCked = 0; rptCked < _rptMethod.length; rptCked++) {
                  let tempRptMethod = _rptMethod[rptCked].value.split(':')
                  if (tempRptMethod[tempRptMethod.length - 2] === propsName) {
                    _isChecked = true;
                    _propsGroupPosition = 9;
                    break;
                  }
                }
                if (_isChecked) {
                  break;
                }
              }

            }
          }
        } else if ((propsName === 'psc1' || propsName === 'psc2' || propsName === 'ac1' || propsName === 'ac2' || propsName === 'other') && propsGroup[0] === 'primaryAndAditionalUserTraining') {
          for (let userTrainItem of this.props.formData[propsGroup[0]]) {
            let userTrainType = userTrainItem.value.split(':');
            if (userTrainType[userTrainType.length - 2] === propsName) {
              _isChecked = true;
              _propsGroupPosition = 9;
              break;
            }
          }
        } else if (propsName === 'confirm') {
          if (this.props.formData[propsGroup[0]]) {
            let dataConfirm = this.props.formData[propsGroup[0]];
            let dataConfirmCheck = dataConfirm.value.split(':');
            if (dataConfirmCheck[dataConfirmCheck.length - 2] === propsName) {
              _isChecked = true;
              _propsGroupPosition = 9;
            }
          }
        }
        if (children) {
          let _partialJsx = [], _value, _ = undefined, _paymentOrder = [];
          let ctr = 0;
          if (propsName === 'wps' ||
            propsName === 'spo' ||
            propsName === 'nonWps' ||
            propsName === 'so' ||
            propsName === 'sp' ||
            propsName === 'salary' ||
            propsName === 'autoPayElectonic' ||
            propsName === 'autoPayCredit' ||
            propsName === 'autoPayStatistics' ||
            propsName === 'submissionMethodA' ||
            propsName === 'submissionMethodB'
          ) {
            _paymentOrder.push(propsGroup[propsGroup.length - 1], _paymentIdx);
          }

          for (let item of children) {
            if (typeof item === 'string') {
              if (item.split(':').length > 1) {
                switch (item.split('_')[1]) {
                  case 'txt':
                  case 'xls':
                    _partialJsx.push(this.renderAccordionItems([item]));
                    break;
                  default:
                    console.log('Unknown checkbox');
                }
              } else {
                _value = JSON.parse(JSON.stringify(this.state.originalFormItems.guideContainer.rootPanel.items[item]));
                _partialJsx.push(this.callRelevantComponent(item, _value, _, `${arrIdx}${ctr}`, propsName, _paymentOrder));
                ctr++;
              }

            } else if (typeof item === 'object') {
              let relevantFieldArr = [];
              for (let [mapKey, mapVal] of item.entries()) {
                if (mapKey.startsWith('static_')) {
                  relevantFieldArr.push(new Map([[mapKey, mapVal]]));
                } else {
                  relevantFieldArr.push(mapKey);
                  switch (mapKey.split('_')[1]) {
                    case 'cannedReport':
                    case 'dataFeedReport':
                      if (this.props.formData['submissionMethods'] && this.props.formData['submissionMethods'].length > 0) {
                        for (let i = 0; i < this.props.formData['submissionMethods'].length; i++) {
                          if (this.props.formData['submissionMethods'][i].submissionMethod.value.split(':')[10] === 'submissionMethodA') {
                            let rptDelvrFrmt = this.props.formData['submissionMethods'][i]['reportDeliveryAndFormat']
                            for (var rptDelFrmt of rptDelvrFrmt) {
                              let _rptDelFrmt = rptDelFrmt.reportType.value.split(':');
                              if (_rptDelFrmt[_rptDelFrmt.length - 2] === mapKey.split('_')[1]) {
                                relevantFieldArr.push(new Map([[mapKey, mapVal]]));
                              }
                            }
                          }
                        }
                      }
                      break;
                    default:
                      console.log('Unknown child of checkbox');
                  }
                }
              }
              _partialJsx.push(this.renderAccordionItems(relevantFieldArr));
            }

          }

          _jsx = (
            <div
              key={propsName + '_child_div'}
              className="subcomponent-container-div"
            >
              {_partialJsx}
            </div>
          )

        } else if (propsName === 'CCCentralPay' || propsName === 'VCCentralPay' || propsName === 'PCCentralPay' || propsName === 'CCIndividualPay' || propsName === 'CCIndividualBillCPay' || propsName === 'LodgeCardCentralPay' || propsName === 'FuelCardCentralPay') {
          let _ = undefined;
          let currencyLabelObject = this.getPaymentLabel(props + ':' + propsName, _propsGroupPosition);
          let itemLabelObject = this.getLabelFromCard(props + ':' + propsName, _propsGroupPosition);
          let checkBoxMainClass = classnames({
            "checkbox-container-main-div": true,
            "checkbox-container-children": propsGroup.length > 1 ? true : false,
            "checkbox-report-alignment-cc": propsName === 'CCCentralPay' || propsName === 'VCCentralPay' || propsName === 'PCCentralPay' || propsName === 'CCIndividualPay' || propsName === 'CCIndividualBillCPay' || propsName === 'LodgeCardCentralPay' || propsName === 'FuelCardCentralPay' ? true : false
          })
          _jsx = (
            <div>
              {itemLabelObject !== undefined ?
                <fieldset
                  key={propsGroup[propsGroup.length - 1] + propsName}
                  className={checkBoxMainClass}
                >
                  <legend className="col-lg-4 margin-label">{currencyLabelObject.name}</legend>
                  {itemLabelObject.map((labelItem, index) => (
                    <div className="p-8">
                      <Checkbox
                        onChange={this.handleChange(propsName, _, props, labelItem.id)}
                        id={this.props.name + propsGroup[propsGroup.length - 1] + propsName + '_' + labelItem.name}
                        name={this.props.name + propsGroup[propsGroup.length - 1] + propsName + '_' + labelItem.name}
                        checked={labelItem._isChecked}
                        controlled
                      />
                      <label
                        htmlFor={this.props.name + propsGroup[propsGroup.length - 1] + propsName + '_' + labelItem.name}
                        className="product-enablement-text"
                        style={{ marginLeft: '2rem', maxWidth: '95%' }}
                      >
                        {labelItem.name || 'Unlabelled Checkbox'}
                      </label>
                    </div>
                  ))}
                </fieldset>
                : ''}
            </div>

          )
        } else if (propsName === 'CorporateCard' || propsName === 'PurchasingCard' || propsName === 'VirtualCard' || propsName === 'LodgeCard' || propsName === 'OneCard' || propsName === 'FleetCard') {
          let _ = undefined;
          let labelObject = this.getPaymentLabel1(props + ':' + propsName, _propsGroupPosition);
          let itemLabelObject = this.getLabelFromCard1(props + ':' + propsName, _propsGroupPosition);
          let currencyLabelObject = this.getCurrencyChecked(propsName, itemLabelObject);
          let checkBoxMainClass = classnames({
            "checkbox-container-main-div": true,
            "checkbox-container-children": propsGroup.length > 1 ? true : false,
            "checkbox-report-alignment-cc": propsName === 'CorporateCard' || propsName === 'PurchasingCard' || propsName === 'VirtualCard' || propsName === 'LodgeCard' || propsName === 'OneCard' || propsName === 'FleetCard' ? true : false
          })
          _jsx = (
            <div>
              {itemLabelObject !== undefined ?
                <fieldset
                  key={propsGroup[propsGroup.length - 1] + propsName}
                  className={checkBoxMainClass}
                >
                  <legend tabIndex="0" className="col-lg-4 margin-label">{labelObject.name}</legend>
                  {itemLabelObject.map((labelItem, index) => (
                    <div className="p-8">
                      <Checkbox
                        onChange={this.handleCardType(propsName, _, props, labelItem.id, null)}
                        id={this.props.name + propsGroup[propsGroup.length - 1] + propsName + '_' + labelItem.name}
                        name={this.props.name + propsGroup[propsGroup.length - 1] + propsName + '_' + labelItem.name}
                        checked={labelItem._isChecked}
                        controlled
                      />
                      <label
                        htmlFor={this.props.name + propsGroup[propsGroup.length - 1] + propsName + '_' + labelItem.name}
                        className="product-enablement-text"
                        style={{ marginLeft: '2rem', maxWidth: '95%' }}
                      >
                        {labelItem.name || 'Unlabelled Checkbox'}
                      </label>
                    </div>
                  ))}
                  {currencyLabelObject.map((labelItem, index) => (
                    <div className="p-8">
                      <Checkbox
                        onChange={this.handleCurrencyType(itemLabelObject[0].propsName, _, itemLabelObject[0].props, labelItem.id, itemLabelObject)}
                        id={this.props.name + propsGroup[propsGroup.length - 1] + itemLabelObject[0].propsName + '_' + labelItem.name}
                        name={this.props.name + propsGroup[propsGroup.length - 1] + itemLabelObject[0].propsName + '_' + labelItem.name}
                        checked={labelItem._isChecked}
                        disabled={itemLabelObject[0].isDisabled}
                        controlled
                      />
                      <label
                        htmlFor={this.props.name + propsGroup[propsGroup.length - 1] + itemLabelObject[0].propsName + '_' + labelItem.name}
                        className="product-enablement-text"
                        style={{ marginLeft: '2rem', maxWidth: '95%' }}
                      >
                        {labelItem.name || 'Unlabelled Checkbox'}
                      </label>
                    </div>
                  ))}
                </fieldset>
                : ''}
            </div>

          )
        } else if (propsName === 'b2bSolution') {
          let title = JSON.parse(JSON.stringify(this.state.originalFormItems.guideContainer.rootPanel.items['guidecheckbox_' + propsName])).title;
          let itemLabelObject = title ? Translations(title, this.props.lang, this.props.translatedData) : Translations(title, this.props.lang, this.props.translatedData)//{ name: "B2B Solution" }
          let _ = undefined;
          let checkValue = this.isB2BChecked();
          if (checkValue === 'CCCentralPay' || checkValue === 'CCIndividualPay') {
            let checkBoxMainClass = classnames({
              "checkbox-container-main-div": true,
              "checkbox-container-children": propsGroup.length > 1 ? true : false,
              "checkbox-bussiness-alignment": propsName === 'b2bSolution' ? true : false
            })
            _jsx = (
              <div
                key={propsGroup[propsGroup.length - 1] + propsName}
                className={checkBoxMainClass}
              >
                <Checkbox
                  onChange={this.handleChange(propsName, _, props)}
                  id={this.props.name + propsGroup[propsGroup.length - 1] + propsName}
                  name={this.props.name + propsGroup[propsGroup.length - 1] + propsName}
                  checked={this.props.formData[propsName]}
                  controlled
                />
                <label
                  htmlFor={this.props.name + propsGroup[propsGroup.length - 1] + propsName}
                  className="product-enablement-text"
                  style={{ marginLeft: '1rem', maxWidth: '95%' }}
                >
                  {itemLabelObject || 'Unlabelled Checkbox'}
                </label>
              </div>

            )
          }

        } else if (propsName === 'specificDetailsMandatoryCheck' || propsName === 'addressAndContactMandatoryCheck') {
          let title = JSON.parse(JSON.stringify(this.state.originalFormItems.guideContainer.rootPanel.items['guidecheckbox_' + propsName])).title;
          let itemLabelObject = title ? Translations(title, this.props.lang, this.props.translatedData) : Translations(title, this.props.lang, this.props.translatedData)//{ name: "B2B Solution" }
          let _ = undefined;
          let checkBoxMainClass = classnames({
            "checkbox-container-main-div": true,
            "checkbox-container-children": propsGroup.length > 1 ? true : false,
            "checkbox-bussiness-alignment": propsName === 'specificDetailsMandatoryCheck' || propsName === 'addressAndContactMandatoryCheck' ? true : false
          })
          _jsx = (
            <div
              key={propsGroup[propsGroup.length - 1] + propsName}
              className={checkBoxMainClass}
            >
              <Checkbox
                onChange={this.handleChange(propsName, _, props)}
                id={this.props.name + propsGroup[propsGroup.length - 1] + propsName}
                name={this.props.name + propsGroup[propsGroup.length - 1] + propsName}
                checked={this.props.formData[propsName]}
                controlled
              />
              <label
                htmlFor={this.props.name + propsGroup[propsGroup.length - 1] + propsName}
                className="product-enablement-text"
                style={{ maxWidth: '95%' }}
              >
                {itemLabelObject || 'Unlabelled Checkbox'}
              </label>
            </div>

          )
        }
        else {
          let itemLabelObject = this.getLabelFromTaxonomy(props + ':' + propsName, _propsGroupPosition);
          let _ = undefined;
          let checkBoxMainClass = classnames({
            "checkbox-container-main-div": true,
            "checkbox-container-children": propsGroup.length > 1 ? true : false,
            "checkbox-report-alignment": propsName === 'eChannel' || propsName === 'other' ? true : false
          })
          _jsx = (
            <div
              key={propsGroup[propsGroup.length - 1] + propsName}
              className={checkBoxMainClass}
            >
              <Checkbox
                onChange={this.handleChange(propsName, _, props)}
                id={this.props.name + propsGroup[propsGroup.length - 1] + propsName}
                name={this.props.name + propsGroup[propsGroup.length - 1] + propsName}
                checked={_isChecked}
                controlled
              />
              <label
                htmlFor={this.props.name + propsGroup[propsGroup.length - 1] + propsName}
                className="product-enablement-text"
                style={{ marginLeft: '1rem', maxWidth: '95%' }}
              >
                {itemLabelObject.name || 'Unlabelled Checkbox'}
                {itemLabelObject.tooltip ? <FieldLabelToolTip tooltip={itemLabelObject.tooltip} name={this.props.name + propsGroup[propsGroup.length - 1] + propsName} /> : ''}
              </label>
            </div>

          )
        }

        break;
      }
      case 'dropDownSelect': {
        _displayKey = props.options ? JSON.parse(Translations(props.options, this.props.lang, this.props.translatedData)) : [[]];
        _label = props.label ? Translations(props.label, this.props.lang, this.props.translatedData) : Translations(props.title, this.props.lang, this.props.translatedData)//'Select a value from the drop down';
        _mandatoryMessage = props.mandatoryMessage ? Translations(props.mandatoryMessage, this.props.lang, this.props.translatedData) : 'This field is required';
        _placeholder = props._value ? Translations(props._value, this.props.lang, this.props.translatedData) : 'Select from list';
        _tooltip = props.tooltip ? Translations(props.tooltip, this.props.lang, this.props.translatedData) || false : false;
        _createLinkText = props.createLinkText ? Translations(props.createLinkText, this.props.lang, this.props.translatedData) || '+ Add item' : '';
        _createLink = props.createLink || '#';
        _editLink = props.editFormLink || '#';
        let _parentIdx;
        let splitParent = parent.split('%');
        if (splitParent.length > 1) {
          parent = splitParent[0];
          _parentIdx = splitParent[1];
        } else {
          parent = splitParent.join('');
        }

        _editable = props.editable ? JSON.parse(props.editable) : false;
        _optionKey = props.optionsId ? Translations(props.optionsId, this.props.lang, this.props.translatedData) : 'id';
        _name = idx === -1 ? props.name : props.name + '_' + idx;

        //Check whether the dropdown is part of a repeating aggregate form box
        if (parent && typeof parent === 'string' && parent.trim() !== '') {
          let aggParentKey = 'guideaggregateformbox_' + parent;
          if (this.state.originalFormItems.guideContainer.rootPanel.items[aggParentKey]) {
            if (this.state.originalFormItems.guideContainer.rootPanel.items[aggParentKey].addItemButton) {
              _isRepeatingField = true;
            }
          }
        }

        // get the current value of the field in 'formData' object using 'orderChain'
        if (parent === 'cannedReport' || parent === 'dataFeedReport') {
          let submisIdx = -1, rptidx = -1, rptFormtidx = -1
          for (let r = 0; r < this.props.formData.submissionMethods.length; r++) {
            if (this.props.formData['submissionMethods'][r].submissionMethod.value.split(':')[10] === 'submissionMethodA') {
              let rptMethod = this.props.formData.submissionMethods[r].reportDeliveryAndFormat;
              submisIdx = r;
              for (let rpt = 0; rpt < rptMethod.length; rpt++) {
                let _rptMethodValue = rptMethod[rpt].reportType.value.split(':');
                if (_rptMethodValue[_rptMethodValue.length - 2] === parent && props.name !== 'reportFormat') {
                  rptidx = rpt
                  break;
                } else if (_rptMethodValue[_rptMethodValue.length - 2] === 'dataFeedReport' && rptMethod[rpt]['reportFormat'] === undefined) {
                  rptidx = rpt
                } else if (_rptMethodValue[_rptMethodValue.length - 2] === parent && props.name === 'reportFormat' && rptMethod[rpt]['reportFormat'] !== undefined) {
                  rptidx = rpt
                  rptFormtidx = 0;
                }
              }
            }
          }
          if (rptFormtidx === 0) {
            orderChain = ['submissionMethods', submisIdx, 'reportDeliveryAndFormat', rptidx, 'reportFormat', rptFormtidx];
          } else {
            orderChain = ['submissionMethods', submisIdx, 'reportDeliveryAndFormat', rptidx];
          }

        }
        _selectedValue = this.selectValueForSimpleComponent(orderChain, props);

        let _disbaledOptionKey;
        //get the source of data to populate the drop down options

        if (this.props._dropDownDataSourceMap.has(props.name)) {
          _dropDownOptionsSourceKey = this.props._dropDownDataSourceMap.get(props.name);
          _disbaledOptionKey = parent && parent.trim() !== '' ? `${parent}${_parentIdx ? _parentIdx : ''}${_dropDownOptionsSourceKey}` : props.name + _dropDownOptionsSourceKey;
        }

        //populate disabledoptions list if value exists for the given dropdown field and is not already present in disabled options list
        let currentVal = _selectedValue;
        if (currentVal && currentVal.trim() !== '') {
          if (this.props.dropDownDataDisabled[_disbaledOptionKey]) {
            if (this.props.formData.cardDeliveryAddressId === undefined && this.props.name === "addressAndContacts") {
              delete this.props.dropDownDataDisabled.cardDeliveryAddressIdcardAddresses;
            }
            if (this.props.formData.pinDeliveryAddressId === undefined && this.props.name === "addressAndContacts") {
              delete this.props.dropDownDataDisabled.pinDeliveryAddressIdpinAddresses;
            }
            if (!this.props.dropDownDataDisabled[_disbaledOptionKey].includes(currentVal)) {
              this.props.updateDisabledOptionArray({
                currentValue: currentVal,
                updateValue: currentVal,
                dataSourceKey: _dropDownOptionsSourceKey,
                disbaledOptionKey: _disbaledOptionKey
              });
            }
          } else {
            this.props.updateDisabledOptionArray({
              currentValue: currentVal,
              updateValue: currentVal,
              dataSourceKey: _dropDownOptionsSourceKey,
              disbaledOptionKey: _disbaledOptionKey
            });
          }
        }
        _persistDataStore = {
          dropDownName: idx === -1 ? props.name : props.name + idx,
          disbaledOptionKey: _disbaledOptionKey,
          dataSourceKey: _dropDownOptionsSourceKey,
          paymentType: this.setPaymentTypeForDD,
          accordionName: this.props._accordionName,
          orderChain: parent.trim() !== '' ? parent + '_' + _name : _name
        }
        _jsx = (
          <WrappedDropDownSelect
            key={_elementKey}
            name={_name}
            repeatComponentIdx={idx}
            options={this.props.dropDownData[_dropDownOptionsSourceKey] || []}
            disabledOptionsId={this.props.dropDownDataDisabled[_disbaledOptionKey] || []}
            disbaledOptionKey={_disbaledOptionKey}
            dataSourceKey={_dropDownOptionsSourceKey}
            optionKey={_optionKey}
            optionDisplayKey={_displayKey}
            placeHolder={_placeholder || "Select from list"}
            customErrorMessage={_mandatoryMessage || "Please select value"}
            selectedValue={_selectedValue}
            onSelect={this.handleChange(parent.trim() !== '' ? parent + '_' + _name : _name, [...orderChain])}
            editable={_editable}
            handleEdit={this.persistData}
            required={props.mandatory === "true" ? true : false}
            editLink={_editLink}
            persistDataStore={_persistDataStore}
            label={_isRepeatingField ? `${_label} ${idx <= 0 ? 1 : idx + 1}` : _label}
            stateData={this.props.stateData}
            history={this.props.history}
            linkTo={props.createLink ? { title: _createLinkText, link: _createLink } : false}
            dropDownHeading={props.dropDownHeading || ''}
            tooltip={_tooltip}
            simpleDropDown={props.simpleDropDown}
            repeatingField={_isRepeatingField}
          />
        );

        break;
      }
      case 'groupCheckBox': {
        _name = props.name;
        _allSelectorValue = props.allSelectorValue || undefined;
        _allSelectorPosition = props.allSelectorPosition || undefined;

        _selectedValue = this.selectValueForComposedComponent(orderChain, props);

        //get the appropriate index of relevant priviledges for rendering
        let relevantAvailablePriviledges = this.findRelevantCheckBoxTaxonomyGroup(props.name);

        _jsx = (
          <GroupCheckBox
            checkBoxData={relevantAvailablePriviledges}
            key={_name}
            checkBoxName={_name}
            checkBoxIndex={idx}
            handleOnChange={this.handleChange(_name, [...orderChain])}
            checkedBoxes={_selectedValue}
            allSelectorValue={_allSelectorValue}
            allSelectorPosition={_allSelectorPosition ? +(_allSelectorPosition) : undefined}
          />
        );
        break;
      }
      case 'inputField': {
        _label = props.title ? Translations(props.title, this.props.lang, this.props.translatedData) : '';
        _placeholder = props.placeHolder ? Translations(props.placeHolder, this.props.lang, this.props.translatedData) : 'Enter text';
        _type = props.type || 'text';
        _mandatoryMessage = props.mandatoryMessage ? Translations(props.mandatoryMessage, this.props.lang, this.props.translatedData) : 'Enter required value';
        _name = idx === -1 ? props.name : props.name + '_' + idx;
        _tooltip = props.tooltip ? Translations(props.tooltip, this.props.lang, this.props.translatedData) || false : false;
        _inputPrefix = props.inputPrefix || false;

        let _parentIdx;
        let splitParent = parent.split('%');
        if (splitParent.length > 1) {
          parent = splitParent[0];
          _parentIdx = splitParent[1];
        } else {
          parent = splitParent.join('');
        }


        //Check whether the dropdown is part of a repeating aggregate form box
        if (parent && typeof parent === 'string' && parent.trim() !== '') {
          let aggParentKey = 'guideaggregateformbox_' + parent;
          if (this.state.originalFormItems.guideContainer.rootPanel.items[aggParentKey]) {
            if (this.state.originalFormItems.guideContainer.rootPanel.items[aggParentKey].addItemButton) {
              _isRepeatingField = true;
            }
          } else {
            if (parent === 'additionalSUNs') {
              _isRepeatingField = true;
            }
          }
        }

        //Get the current value of the field in 'formData' object using 'orderChain'
        _selectedValue = this.selectValueForSimpleComponent(orderChain, props);
        // countPrefix prop represents that inputPrefix must be considered with value of input field
        if (props.countPrefix && _inputPrefix) {
          _selectedValue = _selectedValue.trim() !== "" ? _selectedValue.slice(_inputPrefix.length, _selectedValue.length) : _selectedValue;
        }

        _jsx = (
          <WrappedInputField
            placeholder={_placeholder}
            type={_type}
            key={_elementKey}
            name={_name}
            repeatComponentIdx={idx}
            value={_selectedValue}
            onChange={this.handleChange(parent.trim() !== '' ? parent + '_' + _name : _name, [...orderChain])}
            customErrorMessage={_mandatoryMessage}
            maxLength={props.maxChars}
            minLength={props.minChars}
            helperText={props.helperText || ''}
            label={_label}
            disabled={props.disabled ? true : false}
            required={props.mandatory === "true" ? true : false}
            tooltip={_tooltip}
            inputPrefix={_inputPrefix}
            repeatingField={_isRepeatingField}
            countPrefix={props.countPrefix}
            isDeleteIcon={props.isDeleteIcon}
            deleteSupplier={this.onDeleteSupplier}
          />
        );

        break;
      }
      case 'radioButton': {
        //If the radio button is rendered from AEM props is an object while string if rendered from taxonomy API
        let _radioButtonArray = [];
        if (typeof props === 'object') {
          _label = props.label ? Translations(props.label, this.props.lang, this.props.translatedData) : 'Select an option';
          _name = props.name;
          _radioButtonArray = this.translateWordForRadio(props.options);
          _radioButtonArray = _radioButtonArray.map(item => {
            let retItem = {};
            retItem.label = item.split('=')[1];
            retItem.value = item.split('=')[0] === "true" || item.split('=')[0] === "false" ? JSON.parse(item.split('=')[0]) : item.split('=')[0];
            return retItem;
          })

          _selectedValue = this.selectValueForSimpleComponent(orderChain, props);
          if (_selectedValue === undefined || (typeof _selectedValue !== 'boolean' && _selectedValue.trim() === "")) {
            _selectedValue = undefined;
          } else {
            _selectedValue = _selectedValue;
          }

        } else if (typeof props === 'string') {
          _name = elementKey.split('_')[1];
          let propObj = { name: _name };
          _selectedValue = this.selectValueForSimpleComponent(orderChain, propObj);
          let radioAssociations = this.getAssociationsFromTaxonomy(_name + ':' + _name);
          _label = radioAssociations.associationLabel;
          _radioButtonArray = radioAssociations.associationArray.map(item => {
            let retItem = {};
            retItem.label = item.name;
            retItem.value = item.id;
            return retItem;
          });
        }

        let _radioButtonJsx = (
          <RadioButton
            radioOptions={_radioButtonArray}
            handleChange={this.handleChange(parent.trim() !== '' ? parent + '_' + _name : _name, [...orderChain])}
            selectedOption={_selectedValue}
            name={props.name || props}
            id={props.name || props + "radiobtn"}
          />
        )


        _jsx = (<div className="radio-button-main-div" id={props.name}>
          <div className="radio-button-label-div" tabIndex="0" id={props.name + "_"}>
            {_label}
          </div>
          <div className="radio-button-content-div" role="radiogroup" aria-labelledby={props.name + "_"}>
            {_radioButtonJsx}
          </div>
        </div>)

        break;
      }
      case 'staticText': {
        if (elementKey === 'static_text') {
          _jsx = (
            <div key={`${elementKey}_${idx}`} style={{ marginLeft: '1rem' }}>
              {props}
            </div>
          );
        } else if (elementKey === 'static_text_heading') {
          _jsx = (
            <div key={`${elementKey}_${idx}`} style={{ marginLeft: '1rem' }}>
              <h4 className="gdoc-tab-labelText">
                {props.split('$')[0]}
                {props.split('$').length > 1 ? (<FieldLabelToolTip tooltip={props.split('$')[1]} name={`${elementKey}_${idx}`} />) : ''}
              </h4>
            </div>
          );
        } else if (elementKey === 'static_text_note') {
          _jsx = (
            <div key={`${elementKey}_${idx}`} style={{ marginLeft: '1rem', fontWeight: 'bold' }}>
              {props}
            </div>
          );
        }
        if (elementKey === 'static_text_CardTypeCurrencySelction') {
          _jsx = (
            <div key={`${elementKey}_${idx}`} id={elementKey} className='label-14' style={{ marginLeft: '1rem' }}>
              {Translations(props.title, this.props.lang, this.props.translatedData)}
            </div>
          );
        }
        if (elementKey === 'static_text_staticText') {
          _jsx = (
            <div key={`${elementKey}_${idx}`} id={elementKey} className='label-14' style={{ marginLeft: '1rem' }}>
              {Translations(props.title, this.props.lang, this.props.translatedData)}
            </div>
          );
        }
        if (elementKey === 'static_text_CardsAndPINs') {
          _jsx = (
            <div key={`${elementKey}_${idx}`} id={elementKey} className='label-14' style={{ marginLeft: '1rem' }}>
              {Translations(props.title, this.props.lang, this.props.translatedData)}
            </div>
          );
        }
        if (elementKey === 'static_text_B2BTextField') {
          _jsx = (
            <div key={`${elementKey}_${idx}`} id={elementKey} className='label-14' style={{ marginLeft: '1rem' }}>
              {Translations(props.title, this.props.lang, this.props.translatedData)}
            </div>
          );
        }
        break;
      }
      default:
        console.log('Encountered unknown component of type: ', componentType, 'props: ', props);
    }
    return _jsx;
  }

  isB2BChecked = () => {
    let _propsGroupPosition = 9;
    let currType = this.props.formData.currencyType;
    let currName = [];
    for (let i = 0; i < currType.length; i++) {
      let item = currType[i].value.split(':');
      currName.push(item[_propsGroupPosition]);
    }
    let isB2BCheck = currName.find(x => x === 'CCCentralPay' || x === 'CCIndividualPay');
    return isB2BCheck;
  }

  handleTextboxForm = () => {
    let setRelevantField = this.state.setRelevantField;
    setRelevantField.splice(16, 0, "guidetextbox_paymentFacilitatorName");
    this.setState({ setRelevantField })
    if (this.props.formData.supplierNameLst1 !== undefined && this.props.formData.supplierNameLst1 !== null) {
      document.querySelector('[id^="supplierNameLst2"]').classList.remove('noDisplay')
      if (this.props.formData.supplierNameLst2 !== undefined && this.props.formData.supplierNameLst2 !== null) {
        document.querySelector('[id^="supplierNameLst3"]').classList.remove('noDisplay')
        if (this.props.formData.supplierNameLst3 !== undefined && this.props.formData.supplierNameLst3 !== null) {
          document.querySelector('[id^="supplierNameLst4"]').classList.remove('noDisplay')
          if (this.props.formData.supplierNameLst4 !== undefined && this.props.formData.supplierNameLst4 !== null) {
            document.querySelector('[id^="supplierNameLst5"]').classList.remove('noDisplay')
            document.querySelector('[id^="addSupplier"]').classList.add('noDisplay')
            if (this.props.formData.supplierNameLst5 !== undefined && this.props.formData.supplierNameLst5 !== null) {
              document.querySelector('[id^="addSupplier"]').classList.add('noDisplay');
            }
          }
        }
      }
    }
  }

  onDeleteSupplier = (field) => {
    let changedData = { ...this.props.formData };
    if (document.querySelector(`[id^=${field}]`) !== undefined && document.querySelector(`[id^=${field}]`) !== null) {
      if (field.startsWith('supplierNameLst2')) {
        changedData[field] = changedData['supplierNameLst3']
        changedData['supplierNameLst3'] = null;
        changedData['supplierNameLst3'] = changedData['supplierNameLst4']
        changedData['supplierNameLst4'] = null;
        changedData['supplierNameLst4'] = changedData['supplierNameLst5']
        changedData['supplierNameLst5'] = null;
      }
      if (field.startsWith('supplierNameLst3')) {
        changedData['supplierNameLst3'] = changedData['supplierNameLst4']
        changedData['supplierNameLst4'] = null;
        changedData['supplierNameLst4'] = changedData['supplierNameLst5']
        changedData['supplierNameLst5'] = null;
      }
      if (field.startsWith('supplierNameLst4')) {
        changedData['supplierNameLst4'] = changedData['supplierNameLst5']
        changedData['supplierNameLst5'] = null;
      }
      if (field.startsWith('supplierNameLst5')) {
        changedData['supplierNameLst5'] = null;
      }

      changedData['supplierNameLst2'] === null ? document.querySelector('[id^="supplierNameLst2"]').classList.add('noDisplay') : ' ';
      changedData['supplierNameLst3'] === null ? document.querySelector('[id^="supplierNameLst3"]').classList.add('noDisplay') : ' ';
      changedData['supplierNameLst4'] === null ? document.querySelector('[id^="supplierNameLst4"]').classList.add('noDisplay') : ' ';
      changedData['supplierNameLst5'] === null ? document.querySelector('[id^="supplierNameLst5"]').classList.add('noDisplay') : ' ';
    }
    this.props.onChange(changedData);
  }

  callRelevantComponent = (key, value, idx, children = undefined, parentName = '', orderChain = []) => {
    let formFields = [];
    let _ = undefined;
    switch (key.split('_')[0]) {
      case 'guideaggregateformbox':
        formFields.push(this.renderComponent('aggregateForm', key, value, _, parentName, idx, children, orderChain));
        break;
      case 'guidebutton':
        formFields.push(this.renderComponent('button', key, value, _, parentName, idx, children, orderChain));
        break;
      case 'guidecheckbox':
        formFields.push(this.renderComponent('checkbox', key, value, _, parentName, idx, children, orderChain));
        break;
      case 'guidedropdownlist':
        formFields.push(this.renderComponent('dropDownSelect', key, value, _, parentName, idx, children, orderChain));
        break;
      case 'guidegroupcheckbox':
        formFields.push(this.renderComponent('groupCheckBox', key, value, _, parentName, idx, children, orderChain))
        break;
      case 'guideradiobutton':
        formFields.push(this.renderComponent('radioButton', key, value, _, parentName, idx, children, orderChain));
        break;
      case 'guidetextbox':
        formFields.push(this.renderComponent('inputField', key, value, _, parentName, idx, children, orderChain));
        break;
      case 'static':
        formFields.push(this.renderComponent('staticText', key, value, _, _, idx, _, _));
        break;
      default:
        return formFields;
    }
    return formFields;
  }

  renderAccordionItems = (relevantFields) => {
    let formFieldsAccumulated = [];
    //this.props.accordionFields.formRef ? this.getFormRefData(FORM_REFS[this.props.accordionFields.formRef]): console.log('Form Ref Not Present');;
    if (Object.keys(this.state.originalFormItems).length > 0) {
      let idx = 0, _value;
      for (let key of relevantFields) {
        if (typeof key === 'string') {
          if (key.split(':').length > 1) {
            //This is handling for checkboxes which have a key in the format e.g. paymentTypes:guidecheckbox_wps
            _value = key.split(':')[0];
            key = key.split(':')[1];
          } else {
            _value = JSON.parse(JSON.stringify(this.state.originalFormItems.guideContainer.rootPanel.items[key]));
          }
          formFieldsAccumulated.push([...this.callRelevantComponent(key, _value, idx)]);
        } else if (typeof key === 'object') {
          for (let [k, v] of key.entries()) {
            if (k === "static_text" || k === "static_text_heading" || k === "static_text_note" || k === "static_text_B2B") {
              _value = v;
              formFieldsAccumulated.push([...this.callRelevantComponent(k, _value, idx)]);
            } else {
              if (k.split(':').length > 1) {
                _value = k.split(':')[0];
                k = k.split(':')[1];
              } else {
                _value = JSON.parse(JSON.stringify(this.state.originalFormItems.guideContainer.rootPanel.items[k]));
              }
              formFieldsAccumulated.push([...this.callRelevantComponent(k, _value, idx, v)]);
            }
          }
        }
        idx++;
      }
    }
    return formFieldsAccumulated;
  }


  showNavAccordion() {
    var navList = document.getElementsByClassName("navAccDetails");
    var downIconNavAcc = document.getElementsByClassName("downIconNavAcc");
    for (var i = 0; i < navList.length; i++) {
      navList[i].onclick = (function () {
        /* Toggle between hiding and showing the active panel */
        var panel = this.nextElementSibling;
        panel.classList.remove('gdocs-wrapper');
        if (panel.className === "gdocs-display-block") {
          for (var v = 0; v < navList.length; v++) {
            navList[v].nextElementSibling.className = "gdocs-display-none";
            navList[v].childNodes[0].setAttribute("aria-expanded", "false");
            downIconNavAcc[v].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
          }
          panel.className = "gdocs-display-none";
          this.childNodes[0].setAttribute("aria-expanded", "false")
          if (this.childNodes[0].children[1].children[3] !== undefined) {
            this.childNodes[0].children[1].children[3].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
          } else {
            this.childNodes[0].children[1].children[2].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
          }
        } else {
          for (var v = 0; v < navList.length; v++) {
            navList[v].nextElementSibling.className = "gdocs-display-none";
            navList[v].childNodes[0].setAttribute("aria-expanded", "false");
            downIconNavAcc[v].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
          }
          panel.className = `${"gdocs-display-block"} ${"gdocs-wrapper"}`
          this.childNodes[0].setAttribute("aria-expanded", "true")
          if (this.childNodes[0].children[1].children[3] !== undefined) {
            this.childNodes[0].children[1].children[3].className = "icon icon-chevron-up downIconNavAcc gdocs-float-left";
          } else {
            this.childNodes[0].children[1].children[2].className = "icon icon-chevron-up downIconNavAcc gdocs-float-left";
          }
        }
      });
    }
  }

  showNavAccordionOnEnter() {
    var navList = document.getElementsByClassName("navAccDetails");
    var downIconNavAcc = document.getElementsByClassName("downIconNavAcc");
    for (var i = 0; i < navList.length; i++) {
      navList[i].onkeyup = (function (e) {
        /* Toggle between hiding and showing the active panel */
        if (e.keyCode === 13 || e.keyCode === 32) {
          var panel = this.nextElementSibling;
          if (panel.className === "gdocs-display-block") {
            for (var v = 0; v < navList.length; v++) {
              navList[v].nextElementSibling.className = "gdocs-display-none";
              navList[v].childNodes[0].setAttribute("aria-expanded", "false");
              downIconNavAcc[v].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
            }
            panel.className = "gdocs-display-none";
            this.childNodes[0].setAttribute("aria-expanded", "false");
            if (this.childNodes[0].children[1].children[3] !== undefined) {
              this.childNodes[0].children[1].children[3].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
            } else {
              this.childNodes[0].children[1].children[2].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
            }
          } else {
            for (var v = 0; v < navList.length; v++) {
              navList[v].nextElementSibling.className = "gdocs-display-none";
              navList[v].childNodes[0].setAttribute("aria-expanded", "false");
              downIconNavAcc[v].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
            }
            panel.className = "gdocs-display-block";
            this.childNodes[0].setAttribute("aria-expanded", "true")
            if (this.childNodes[0].children[1].children[3] !== undefined) {
              this.childNodes[0].children[1].children[3].className = "icon icon-chevron-up downIconNavAcc gdocs-float-left";
            } else {
              this.childNodes[0].children[1].children[2].className = "icon icon-chevron-up downIconNavAcc gdocs-float-left";
            }
          }
        }
      });
    }
  }

  render() {
    return (
      <div className={classnames({
        'noDisplay': this.props.hideAccordian,
        'navAccContainer': true
      })}>
        <div className="navAccDetails" >
          <div role="button" aria-expanded="false" tabIndex="0" onClick={this.props._onClickAccordionHeader}>
            <div className="gdocs-float-left">
              <span className='NavListAccordionHead'>{this.props.navAccHeading}</span>
            </div>
            <div className="gdocs-float-right">
              {
                this.props.status !== 'optional' ? (
                  <div className="statusNavcAcc gdocs-float-left">{translateStatus(this.props.lang, this.props.status) || this.props.status}</div>
                ) : ''
              }
              {
                this.props.status !== 'optional' ? (
                  <div className={this.props.status === 'complete' ? 'icon icon-circle-confirmation-solid iconNavAccStatus' : 'icon icon-circle-error-solid case-in-complete-icon'}></div>
                ) : ''
              }
              {
                this.props.status === 'optional' ? (
                  <div className="statusNavcAcc gdocs-float-left">
                    <span className="optional-status">{translateStatus(this.props.lang, this.props.status)}</span>
                  </div>
                ) : ''
              }
              <div className="separatorNavAcc gdocs-float-left"></div>
              <div className="icon icon-chevron-down downIconNavAcc gdocs-float-left" dir="dirNav"></div>
            </div>
            <div className="gdocs-clear-float"></div>
          </div>
        </div>
        <div className="gdocs-display-none">
          {this.renderAccordionItems(this.props.relevantFields)}
        </div>
      </div>
    );
  }
}

export default CorporateCardAccordion;

CorporateCardAccordion.defaultProps = {
  hideAccordian: false
}

export class NavListAccordionWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.navList = document.getElementsByClassName("navAccDetails");
  }

  componentDidUpdate() {
    if ((this.props.open === 0 || this.props.open) && this.navList.length > 0) {
      this.navList[this.props.open].nextElementSibling.className = "gdocs-display-block";
    }
  }

  render() {
    return (
      <div className="nav-list-accordion-wrapper">
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/CorporateCardAccordion/corporateCardAccordion.js